// Shared guards for controllers that open a modal on a bare keydown shortcut.

function isTyping(el) {
  return (
    el.tagName === 'INPUT' ||
    el.tagName === 'TEXTAREA' ||
    el.isContentEditable ||
    el.closest('[contenteditable=true]')
  );
}

function hasModifierKey(e) {
  return e.ctrlKey || e.altKey || e.metaKey || e.shiftKey;
}

// A maximized fullscreen container (assistant, mapping editor) or a modal dialog covers the page,
// so page-level shortcuts would act behind it. Each fullscreen controller marks its own container;
// the global html.fullscreen-active class is shared, so the last controller to toggle wins.
export function pageIsCovered() {
  return !!document.querySelector(
    '[data-fullscreen-target~="container"].fullscreen, dialog[open]:modal'
  );
}

function modalIsOpen() {
  return (
    pageIsCovered() ||
    !!document.querySelector('dialog[open], [data-controller~="action-modal"]:not([hidden])')
  );
}

export function canOpenViaShortcut(e) {
  return !hasModifierKey(e) && !isTyping(e.target) && !modalIsOpen();
}
